// extracted by mini-css-extract-plugin
module.exports = {"toastWrapper":"NotificationArea_toastWrapper__8pZ0P","toast":"NotificationArea_toast__fXIh7","alert":"NotificationArea_alert__VqLIb"};